import type { ReactNode } from 'react';

import { cn } from '@/lib/shadcn/utils';

const chipTones = {
  draft: { chip: 'bg-amber-50 text-amber-800', dot: 'bg-amber-500' },
  decision: { chip: 'bg-secondary-150 text-primary-700', dot: 'bg-primary' },
  neutral: { chip: 'bg-muted text-neutral-600', dot: 'bg-neutral-500' },
  done: { chip: 'bg-muted text-neutral-600', dot: 'bg-green-600' },
  failed: { chip: 'bg-red-50 text-red-700', dot: 'bg-red-500' },
};

interface StatusChipProps {
  tone: keyof typeof chipTones;
  children: ReactNode;
}

/**
 * A row's status as a dotted pill. Shared by the job pipeline and the
 * Outreach page so a failed message looks the same in both.
 */
export function StatusChip({ tone, children }: StatusChipProps) {
  return (
    <span
      className={cn(
        'inline-flex h-6 max-w-full items-center gap-1.5 rounded-full px-2 text-xs font-medium whitespace-nowrap',
        chipTones[tone].chip,
      )}
    >
      <span
        className={cn('size-1.5 shrink-0 rounded-full', chipTones[tone].dot)}
      />
      <span className="truncate">{children}</span>
    </span>
  );
}
